import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';

import { FinnairOrder } from '@fcom/dapi/api/models';
import { IdAndHash } from '@fcom/dapi';

import { OrderStatus } from '../../../store';

@Injectable()
export class PurchaseSuccessService {
  PARAM_ORDER_ID = 'orderid';
  PARAM_HASH = 'hash';

  orderHasToBeRefetched(
    order: FinnairOrder,
    status: OrderStatus,
    fetchInformation: IdAndHash,
    paramMap: ParamMap
  ): boolean {
    const isOrderDataValid = order?.id === fetchInformation?.id;

    return this.hasOrderQueryParams(paramMap) || !isOrderDataValid || status === OrderStatus.LOAD_ERROR;
  }

  hasOrderQueryParams(paramMap: ParamMap): boolean {
    const requestedOrderId = paramMap.has(this.PARAM_ORDER_ID);
    const requestedHash = paramMap.has(this.PARAM_HASH);

    return requestedOrderId && requestedHash;
  }
}
